


// src/components/WorkSection.js
import React from 'react';
import Work from '../pages/Work';  // Import the Work component
import "./work.css"
import second from '../assets/second.png'
import third from '../assets/third.png'
import fourth from '../assets/fourth.png'
import fifth from '../assets/Fifth.png'


const WorkSection = () => {
  return (
    <div>
      <h1 className='align'>See how it works</h1>
      <p className='align'>Simple, intuitive, and designed for everyone</p>

      {/* Cards container */}
      <div className="image">
        <Work img={second} />
        <Work img={third} />
        <Work img={fourth} />
        <Work img={fifth} />
      </div>
    </div>
  );
};

export default WorkSection;
